import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const DebtorSwitcherWrapper = styled.div`
  display: flex;
  align-items: left;
  min-width: ${rem(300)};
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const SwitcherInput = styled.input`
  width: 100%;
  padding: ${rem(8)} ${rem(12)} ${rem(8)} ${rem(8)};
  border: 1px solid ${({ theme }: any) => theme.colors.greyscale.gray30};
  border-radius: ${rem(4)};
  font-size: ${rem(14)};
  background: ${({ theme }: any) => theme.colors.greyscale.white};
  color: ${({ theme }: any) => theme.colors.greyscale.gray90};

  &:focus {
    outline: none;
    border-color: ${({ theme }: any) => theme.colors.primary.default};
  }
`;

export const SuggestionsContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${({ theme }: any) => theme.colors.greyscale.white};
  border: 1px solid ${({ theme }: any) => theme.colors.greyscale.gray30};
  border-radius: ${rem(4)};
  max-height: ${rem(300)};
  overflow-y: auto;
  box-shadow: 0 ${rem(4)} ${rem(8)} rgba(0, 0, 0, 0.1);
`;

export const SuggestionList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const NoResultsContainer = styled.div`
  padding: ${rem(12)};
  color: ${({ theme }: any) => theme.colors.greyscale.gray50};
  font-size: ${rem(14)};
`;

export const LoadingContainer = styled.div`
  padding: ${rem(12)};
`;

export const HelpText = styled.div`
  padding: ${rem(12)};
  color: ${({ theme }: any) => theme.colors.greyscale.gray50};
  font-size: ${rem(12)};
`;